import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Navigation.css';

const Navigation = ({ titles, visibilities }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const pages = [
    { key: 'paasarja', path: '/paasarja' },
    { key: 'shuffle_cup', path: '/shuffle-cup' },
    { key: 'touge', path: '/touge' },
    { key: 'hotlap_hontsa', path: '/hotlap-hontsa' },
    { key: 'wall_of_champions', path: '/wall-of-champions' },
  ];

  return (
    <nav className="main-nav">
      <button className="menu-toggle" onClick={toggleMenu}>
        &#9776;
      </button>
      <ul className={isOpen ? 'nav-links open' : 'nav-links'}>
        <li onClick={() => setIsOpen(false)}><NavLink to="/info" activeClassName="active">INFO</NavLink></li>
        {pages.map(page => (
          (visibilities[page.key] !== false) && (
            <li key={page.key} onClick={() => setIsOpen(false)}>
              <NavLink to={page.path} activeClassName="active">{titles[page.key]}</NavLink>
            </li>
          )
        ))}
        <li onClick={() => setIsOpen(false)}><NavLink to="/admin" activeClassName="active">ADMIN</NavLink></li>
      </ul>
    </nav>
  );
};

export default Navigation;
